import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import VehicleTaxService from "../services/vehicleTaxService";
import VehicleTypeService from "../services/VehicleTypeService";
import VehicleRegistrationService from "../services/vehicleRegistrationService";
import Breadcrumb from "../components/Breadcrumb";
import StorageService from "../services/StorageService";
import MessageDialog from "../components/MessageDialog";


export default function AddVehicleTax() {
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("error");
  // const messageTimer = useRef(null);
  const navigate = useNavigate();

  const { id } = useParams();

  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const taxpaidDate = watch("taxpaidDate");

  // Load initial mode (Add / Modify)
  useEffect(() => {
    if (id) {
      setEditLoading(true);
      setEditMode(true);
      setEditId(id);
      fetchTaxById(id);
    } else {
      reset({ status: "Active" });
    }

    loadVehicleTypes();
  }, [id]);

  // Fetch Vehicle Types
  const loadVehicleTypes = async () => {
    try {
      const res = await VehicleTypeService.getActiveVehicleTypes();
      setVehicleTypes(res.data || []);
    } catch {
      setVehicleTypes([]);
    }
  };

  
useEffect(() => {
  if (!editMode) {
    const today = new Date().toISOString().split("T")[0];
    setValue("taxpaidDate", today);
  }
}, [editMode, setValue]);

  

  const fetchVehicles = async (vehicleTypeId) => {
  if (!vehicleTypeId) return;

  try {
    const activeCompany = StorageService.activeCompany();

    if (!activeCompany?.companyId) {
      console.error("Company ID missing");
      setVehicles([]);
      return;
    }

    // API CALL
    const res = await VehicleRegistrationService.getByVehicleTypeId(
      vehicleTypeId,
      activeCompany.companyId
    );

    // CORRECT DATA EXTRACTION
    const data =
      res?.data ||               
      res?.data?.data ||         
      res ||                     
      [];

    setVehicles(Array.isArray(data) ? data : []);
  } catch (error) {
    console.error("Error fetching vehicles:", error);
    setVehicles([]);
  }
};



  
  const fetchTaxById = async (taxId) => {
    setLoading(true);
    setEditLoading(true);
    try {
      const res = await VehicleTaxService.getById(taxId);

      if (res?.data) {
        const record = res.data;

        // Load vehicles based on vehicleType
        if (record.vehicleTypeId) {
          await fetchVehicles(record.vehicleTypeId);
        }

        // Format dates
        const formValues = {
          vehicleTypeId: record.vehicleTypeId || "",
          vehicleId: record.vehicleId || "",
          taxpaidDate: record.taxPaidDate
            ? new Date(record.taxPaidDate).toISOString().split("T")[0]
            : "",
          nexttaxDate: record.nextTaxDate
            ? new Date(record.nextTaxDate).toISOString().split("T")[0]
            : "",
          status: record.status || "Active",
        };

        reset(formValues);
      } else {
        showMessage("Failed to load Vehicle Tax Record.", "error");
      }
    } catch (error) {
      console.log(error);
      showMessage("Error fetching Vehicle Tax details.", "error");
    } finally {
      setLoading(false);
      setEditLoading(false);
    }
  };

  // Show message helper
  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 3000);
  };

  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };

  // Submit handler
  const onSubmit = async (data) => {
    setLoading(true);

    try {
      // Convert date field names correctly
      data.taxPaidDate = data.taxpaidDate;
      data.nextTaxDate = data.nexttaxDate;

      delete data.taxpaidDate;
      delete data.nexttaxDate;

      // Validate vehicle
      // if (!data.vehicleId) {
      //   showMessage("Please select a vehicle", "error");
      //   setLoading(false);
      //   return;
      // }

      // Set companyId automatically
      const selectedVehicle = vehicles.find(
        (v) => v.id === Number(data.vehicleId)
      );
      data.companyId = selectedVehicle?.companyId || null;

      let res;

      if (editMode) {
        data.updatedBy = StorageService.loginData().employeeId;
        res = await VehicleTaxService.update(editId, data);

        showMessage("Vehicle Tax updated successfully", "success");
      } else {
        data.createdBy = StorageService.loginData().employeeId;
        res = await VehicleTaxService.create(data);

        showMessage("Vehicle Tax added successfully", "success");
      }

      setTimeout(() => navigate("/cpnl/vehicletax/view"), 1200);
    } catch (error) {
      showMessage(
        error?.response?.data?.message ||
          "Failed to save Vehicle Tax. Try again.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  // Cancel handler
  const handleCancel = () => navigate("/cpnl/vehicletax/view");

  return (
    <>
      <Breadcrumb
        pageTitle={editMode ? "Modify Vehicle Tax" : "Add Vehicle Tax"}
        secondTitle="Vehicle Management"
      />

      <div className="row">
        <div className="card py-2 bg-white shadow-sm">
          {/* {message && (
            <div
              className={`alert ${
                msgType === "success" ? "alert-success" : "alert-danger"
              } d-flex justify-content-between align-items-center mb-2 p-2`}
            >
              <span>{message}</span>
              <button className="btn-close" onClick={closeMessage}></button>
            </div>
          )} */}
          
            <MessageDialog
              message={message}
              type={msgType}
              setMessage={setMessage}
              setMsgType={setMsgType}
            />
          

          {editLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary"></div>
              <div className="mt-2 text-muted">Loading VehicleTax details...</div>
            </div>
          ) : (
              
            <form onSubmit={handleSubmit(onSubmit)} noValidate>
              <div className="row">
                {/* VEHICLE TYPE */}
                <div className="mb-3 col-md-6">
                  <label className="form-label">
                    Vehicle Type <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    // {...register("vehicleTypeId", {
                    //   required: "Vehicle Type is required",
                    // })}

                    {...register("vehicleTypeId")}
                    onChange={(e) => fetchVehicles(e.target.value)}
                  >
                    <option value="">Select Vehicle Type</option>
                    {vehicleTypes.map((t) => (
                      <option key={t.id} value={t.id}>
                        {t.vehicleType}
                      </option>
                    ))}
                  </select>
                  {/* {errors.vehicleTypeId && (
                    <small className="text-danger">
                      {errors.vehicleTypeId.message}
                    </small>
                  )} */}
                </div>

                {/* VEHICLE NAME */}
                <div className="mb-3 col-md-6">
                  <label className="form-label">
                    Vehicle Name <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    // {...register("vehicleId", {
                    //   required: "Vehicle Name is required",
                      // })}
                      {...register("vehicleId")}
                  >
                    <option value="">Select Vehicle</option>
                    {vehicles.map((v) => (
                      <option key={v.id} value={v.id}>
                        {v.vehicleName}
                      </option>
                    ))}
                  </select>
                  {/* {errors.vehicleId && (
                    <small className="text-danger">
                      {errors.vehicleId.message}
                    </small>
                  )} */}
                </div>
              </div>

              <div className="row">
                {/* TAX PAID DATE */}
                <div className="mb-3 col-md-6">
                  <label className="form-label">
                    Tax Paid Date <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    // {...register("taxpaidDate", {
                    //   required: "Tax Paid Date is required",
                    // })}

                      {...register("taxpaidDate")}
                  />
                  {/* {errors.taxpaidDate && (
                    <small className="text-danger">
                      {errors.taxpaidDate.message}
                    </small> */}
                  {/* )} */}
                </div>

                {/* NEXT TAX DATE */}
                <div className="mb-3 col-md-6">
                  <label className="form-label">
                    Next Tax Date <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    // {...register("nexttaxDate", {
                    //   required: "Next Tax Date is required",
                    //   validate: (value) =>
                    //     !taxpaidDate ||
                    //     new Date(value) > new Date(taxpaidDate) ||
                    //     "Next Tax Date must be greater than Tax Paid Date",
                    // })}

                      {...register("nexttaxDate")}
                  />
                  {/* {errors.nexttaxDate && (
                    <small className="text-danger">
                      {errors.nexttaxDate.message}
                    </small>
                  )} */}
                </div>
              </div>

              <div>
                <button className="btn btn-primary me-2" disabled={loading}>
                  <i className="ti ti-circle-check me-1"></i>
                  {loading
                    ? editMode
                      ? "Updating..."
                      : "Saving..."
                    : editMode
                      ? "Update"
                      : "Save"}
                </button>

                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCancel}
                  disabled={loading}
                >
                  <i className="ti ti-cancel me-1"></i>
                  Cancel
                </button>
              </div>
            </form>
          )}
          
        </div>
      </div>
    </>
  );
}
